<div
  edsGrid
  [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
  edsPadding
  [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
  [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
>
  <eds-breadcrumbs
    [items]="showBreadcrumb ? successPageBreadcrumbs : null"
    theme="basic"
    edsPadding
    edsPaddingLeft="sm"
  >
  </eds-breadcrumbs>
  <div class="container">
    <!-- breadcrumbs  area -->
    <ng-container
      *ngIf="postMailResponse?.orderConfirmationNumber; else orderNotSuccess"
    >
      <div edsSpacing="xl" edsPadding edsPaddingTop="lg">
        <!-- Order Success -->
        <p edsSpacing="xs" class="pre-title">
          {{ "literature.mail-title-order-sccess" | translate }}
        </p>
        <eds-title
          edsSpacing="xs"
          size="h2"
          theme="basic"
          [level]="1"
          [isLight]="true"
          >{{ "literature.lit-order-number" | translate }}
          {{ postMailResponse?.orderConfirmationNumber }}</eds-title
        >
        <eds-title
          edsSpacing="none"
          title="{{
            'literature.mail-title-mailing-order-success-description'
              | translate
          }}"
          size="h6"
          theme="basic"
          [level]="3"
          [isLight]="true"
        ></eds-title>
      </div>
      <div
        edsFlexbox
        [flexDirection]="(isMobile$ | async) ? 'column' : 'row'"
        justifyContent="space-between"
        edsSpacing="xl"
      >
        <div
          edsFlexItem
          flexBasis="40%"
          [edsSpacing]="(isMobile$ | async) ? 'lg' : 'none'"
        >
          <eds-title
            edsSpacing="sm"
            title="{{ 'literature.mail-title-mailing-address' | translate }}"
            size="h6"
            theme="basic"
          ></eds-title>
          <address>
            <p>
              {{ postMailResponse?.submitOrderInformation.firstName }}
              {{ postMailResponse?.submitOrderInformation.lastName }}<br />
              {{ postMailResponse?.submitOrderInformation.addressLine1 }}
              {{ postMailResponse?.submitOrderInformation.addressLine2 }}<br />
              {{ postMailResponse?.submitOrderInformation.city }}<br />
              {{ postMailResponse?.submitOrderInformation.zip }}
            </p>
          </address>
        </div>
        <div edsFlexItem flexBasis="60%">
          <eds-title
            edsSpacing="sm"
            title="{{ 'literature.mail-title-delivery-detail' | translate }}"
            size="h6"
            theme="basic"
          ></eds-title>
          <!-- <p edsSpacing="xs">Standard shipping 5-10 business days</p>
        <p edsSpacing="sm" class="text-grey1">
          For Time sensitive orde please contact customer service at 1800
        </p>
        <p edsSpacing="sm">Delivery Notes included (if any)</p> -->
          <div
            innerHtml="{{
              'literature.lit-mail-order-detail-delivery-information'
                | translate
            }}"
          ></div>
          <p edsSpacing="none">
            {{ "literature.lit-order-date" | translate }}
            {{ orderDate | date: "MM/dd/yyyy" }}
          </p>
        </div>
      </div>
      <eds-title
        edsSpacing="xs"
        title="{{ 'literature.mail-title-order-detail' | translate }}"
        size="h6"
        theme="basic"
      ></eds-title>
      <ng-container *ngIf="cartItems as tableData">
        <div edsFlexbox>
          <p edsPadding edsPaddingRight="sm" edsSpacing="md">
            {{ "literature.cart-total-items" | translate }} :
            {{ tableData.cartItems.length }}
          </p>
          <p class="separator"></p>
          <p edsPadding edsPaddingLeft="sm" edsSpacing="md">
            {{ "literature.overall-quantity" | translate }} :
            {{ getOverAllQty(tableData.cartItems) }}
          </p>
        </div>
        <div edsGrid edsSpacing="lg">
          <div edsRow>
            <table
              class="table table--secondary"
              #tableResponsive
              [style.display]="(isHandheld$ | async) ? 'none' : ''"
            >
              <thead class="table__thead">
                <tr class="table__tr">
                  <th class="table__th">
                    {{ "literature.lit-listing-items" | translate }}
                  </th>
                  <th class="table__th text-align-right">
                    {{ "literature.literature-overall-quantity" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody class="table__body">
                <tr class="table__tr" *ngFor="let data of tableData.cartItems">
                  <td class="table__td">
                    <eds-link-item
                      edsSpacing="md"
                      [title]="data.dctermsTitle"
                      [href]="getLiteratureDetailLink(data.docId)"
                    ></eds-link-item>
                  </td>
                  <td class="table__td text-align-right">
                    {{ "literature.lit-order-qty" | translate }}:
                    {{ data.quantity }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div edsRow *ngFor="let card of cards; let cardIndex = index">
            <div edsCol *ngIf="isHandheld$ | async">
              <eds-panel
                edsSpacing="sm"
                [hasBorders]="true"
                [hasBorderRadius]="true"
                [hasPadding]="true"
              >
                <ng-container *ngFor="let item of card; let itemIndex = index">
                  <eds-info-item
                    *ngIf="itemIndex !== 0"
                    [info]="item"
                    edsSpacing="sm"
                  >
                  </eds-info-item>
                  <ng-container *ngIf="itemIndex === 0">
                    <eds-info-item [info]="item" edsSpacing="sm">
                      {{ removeAndGetLinkValue(item) }}
                      <eds-link-item
                        edsSpacing="sm"
                        [title]="tableData.cartItems[cardIndex].dctermsTitle"
                        [href]="
                          getLiteratureDetailLink(
                            tableData.cartItems[cardIndex].docId
                          )
                        "
                      >
                      </eds-link-item>
                    </eds-info-item>
                  </ng-container>
                </ng-container>
              </eds-panel>
            </div>
          </div>
        </div>
        <div edsFlexbox>
          <div edsPadding edsPaddingRight="sm">
            <button
              edsButton="secondary"
              size="normal"
              [noMargin]="true"
              (click)="navigateToLiteraturePage()"
            >
              <span>{{ "literature.lit-continue-browse" | translate }}</span>
            </button>
          </div>
          <button
            *ngIf="showHistory"
            edsButton="secondary"
            size="normal"
            [noMargin]="true"
            (click)="navigateToOrderHistory()"
          >
            <span>{{
              "literature.mail-order-history-button" | translate
            }}</span>
          </button>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #orderNotSuccess>
      <div edsSpacing="xl" edsPadding edsPaddingTop="lg">
        <eds-notifications
          [hasBorders]="true"
          [hasBorderRadius]="false"
          [hasShadows]="true"
          title=" {{ 'literature.order-not-successful' | translate }}"
          [body]="OrderNotSuccessReason"
          [notificationType]="'error'"
          [canClose]="false"
          [secondaryBtnText]="showHistory ? orderHistoryButtonLabel : ''"
          primaryBtnText="{{ 'literature.lit-continue-browse' | translate }}"
          (btnSubscribe)="navigateTo($event)"
        >
        </eds-notifications>
      </div>
    </ng-template>
  </div>
</div>
